import { ContentItemInfo } from "./content-item-info";
import { StorableObject } from "@app/core/storable-object";

export class ModuleStructure extends StorableObject {
    sections: Array<ContentItemInfo> = new Array<ContentItemInfo>();
    activityItems: Array<ContentItemInfo> = new Array<ContentItemInfo>();
    videos: Array<ContentItemInfo> = new Array<ContentItemInfo>();
    files: Array<ContentItemInfo> = new Array<ContentItemInfo>();
    availableServerVersion: string;
}